import { render, staticRenderFns } from "./UpdatePassword.vue?vue&type=template&id=658be404&scoped=true"
import script from "./UpdatePassword.vue?vue&type=script&lang=ts"
export * from "./UpdatePassword.vue?vue&type=script&lang=ts"
import style0 from "./UpdatePassword.vue?vue&type=style&index=0&id=658be404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658be404",
  null
  
)

export default component.exports